import type Pusher from 'pusher-js';
import type * as PusherTypes from 'pusher-js';

declare var Xert;

export default class XertPusher {
    user_channel: PusherTypes.Channel;
    channels = {};

    public getUserChannel() {
        return this.user_channel;
    }

    public getChannel(channel_name): PusherTypes.Channel {
        let channel = this.channels[channel_name];
        if (channel == null) {
            // init channel here?
        }
        return channel;
    }

    init() {
        const pusher: Pusher = Xert._pusher;
        if (pusher == null) return;

        this.user_channel = Xert._userChannel as PusherTypes.Channel;

        this.channels[Xert._userChannelName] = this.user_channel;
        this.channels['all_sessions'] = pusher.subscribe("all_sessions");
        this.channels['all_session_templates'] = pusher.subscribe("all_session_templates");
    }
    close() {
        Object.values(this.channels).forEach((c: PusherTypes.Channel) => {
            c.unbind();
            c.unsubscribe();
        });

    }
}